(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-quantity-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSurfaceCounter(block) {
      const surfaceEl = block.querySelector('[data-ref="product-quantity-selector"] + .product-quantity-surface, .product-quantity-surface');
      const wrapper = block.matches('[data-ref="product-quantity-selector"]') ? block : block.querySelector('[data-ref="product-quantity-selector"]');
      if (!wrapper) return;

      const surfaceDiv = wrapper.querySelector('.product-quantity-surface');
      if (!surfaceDiv) return;

      const unitSurface = parseFloat(surfaceDiv.dataset.unitSurface);
      if (!unitSurface) return;

      const valueEl = surfaceDiv.querySelector('[data-surface-value]');
      const qtyInput = wrapper.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      function updateSurface() {
        const qty = parseInt(qtyInput.value, 10) || 0;
        const total = (qty * unitSurface);
        valueEl.textContent = total.toLocaleString('fr-FR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }

      qtyInput.addEventListener('input', updateSurface);
      qtyInput.addEventListener('change', updateSurface);
      updateSurface();
    }

    document.querySelectorAll('[data-ref="product-quantity-selector"]').forEach(initSurfaceCounter);

    document.addEventListener('shopify:section:load', function (event) {
      event.target
        .querySelectorAll('[data-ref="product-quantity-selector"]')
        .forEach(initSurfaceCounter);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
